import {Component, OnInit, AfterViewInit} from '@angular/core';
import {DataSharing} from '../../../helpers/core/data.sharing';

@Component({
    selector: 'app-tracker-header',
    templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, AfterViewInit {
    public _settings: any;

    constructor() {
    }

    ngOnInit() {
        const portal_setting = DataSharing.GetJsonObj('settings');
        this._settings = {
            logo: portal_setting.logo,
            logo_description: portal_setting.logo_description
        };
    }

    ngAfterViewInit() {
    }
}
